import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { useEffect } from "react";
import { initNativeApp } from "@/lib/native";
import { initOneSignal } from "@/lib/onesignal";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Clients from "@/pages/admin/Clients";
import Plans from "@/pages/admin/Plans";
import Payments from "@/pages/admin/Payments";
import Notifications from "@/pages/admin/Notifications";
import Campaigns from "@/pages/admin/Campaigns";
import Settings from "@/pages/admin/Settings";
import Deploy from "@/pages/admin/Deploy";
import PlanChanges from "@/pages/admin/PlanChanges";
import ClientLayout from "@/pages/client/ClientLayout";
import ClientHome from "@/pages/client/ClientHome";
import ClientPayments from "@/pages/client/ClientPayments";
import ClientBenefits from "@/pages/client/ClientBenefits";
import ClientNotifications from "@/pages/client/ClientNotifications";
import UpdatePrompt from "@/components/app/UpdatePrompt";

const Guard = ({ role, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-zinc-500">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  return children;
};

const Root = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
};

function App() {
  useEffect(() => {
    initNativeApp();
    initOneSignal();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <UpdatePrompt />
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/login" element={<Login />} />

          <Route path="/admin" element={<Guard role="admin"><AdminLayout /></Guard>}>
            <Route index element={<Dashboard />} />
            <Route path="clientes" element={<Clients />} />
            <Route path="planos" element={<Plans />} />
            <Route path="pagamentos" element={<Payments />} />
            <Route path="notificacoes" element={<Notifications />} />
            <Route path="campanhas" element={<Campaigns />} />
            <Route path="trocas" element={<PlanChanges />} />
            <Route path="configuracoes" element={<Settings />} />
            <Route path="deploy" element={<Deploy />} />
          </Route>

          <Route path="/portal" element={<Guard role="client"><ClientLayout /></Guard>}>
            <Route index element={<ClientHome />} />
            <Route path="pagamentos" element={<ClientPayments />} />
            <Route path="beneficios" element={<ClientBenefits />} />
            <Route path="notificacoes" element={<ClientNotifications />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
